import Skeleton from "react-loading-skeleton";


export default function QuizLoader() {
    return (
        <div className="py-6 bg-primary mx-auto max-w-7xl px-5 lg:px-0">
            <div >
                <Skeleton className="h-5"></Skeleton>
                <Skeleton width={"60%"}></Skeleton>
            </div>
            <div className="mt-8">
                <div className="border border-[#475569] rounded p-3">
                    <Skeleton className="h-5" />
                    <div className="grid grid-cols-2 gap-5 mt-5">
                        <Skeleton className="h-8" />
                        <Skeleton className="h-8" />
                        <Skeleton className="h-8" />
                        <Skeleton className="h-8" />
                    </div>
                </div>
            </div>
        </div>
    )
};